import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import LinkButton from '../../ui/LinkButton';
import AddLocationFormSection from './AddLocationFormSection';
import PractitionerFormContext from './PractitionerFormContext';
import PractitionerInputs from './PractitionerInputs';

interface PractitionerFormSectionProps {
  emailIsVerified: boolean;
  setEmailIsVerified: (value: boolean) => void;
}

const AddButton = styled(LinkButton).attrs({
  type: 'button',
})`
  margin-top: -20px;
  margin-bottom: 32px;
`;

const PractitionerFormSection = ({
  emailIsVerified,
  setEmailIsVerified,
}: PractitionerFormSectionProps) => {
  const [visible, setVisible] = useState(false);
  const { isEditOnly } = useContext(PractitionerFormContext);

  return (
    <React.Fragment>
      <PractitionerInputs
        emailIsVerified={emailIsVerified}
        setEmailIsVerified={setEmailIsVerified}
      />

      {isEditOnly && (
        <React.Fragment>
          {visible ? (
            <AddLocationFormSection onClose={() => setVisible(false)} />
          ) : (
            <AddButton onClick={() => setVisible(true)} iconLeft="add" iconSize={20}>
              Add Location
            </AddButton>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default PractitionerFormSection;
